module.exports = __webpack_public_path__ + "static/img/20150312105358251.5dd047b.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/20150312105358251.gif
// module id = 43
// module chunks = 1